import React from 'react'
import { useSelector } from 'react-redux';
import ScrollToBottom from 'react-scroll-to-bottom';

import Message from './Message'

function AllMessages() {

    let messages = useSelector(state => state.messages);
    let sameUser = false;

    return (
            <ScrollToBottom  className = "all-message-container" >{
                messages.map((msg , idx) => {
                    sameUser = false;
                    if( idx > 1)
                    if( messages[idx-1].user === msg.user) sameUser = true;

                    return <Message 
                    sameUser = {sameUser}
                    key = {idx} 
                    message = {msg}/>
                })
            }
            </ScrollToBottom>
    )
}

export default AllMessages
